import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestPermissions() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/permission`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestVisibilityCheck(body) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/permission/check`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}
